import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import { useCostSupplierCategoriesQueryQuery} from "../../generated/graphql";

export const CostSupplierCategorySelect = (props) => {
    const query = useCostSupplierCategoriesQueryQuery();
    return <GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}
